import React, {useState, useEffect} from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import globals from 'react-global-configuration';

import {Conatiner, Containerfluid, ContainerTxt, Logo, Claim,LogoContainer,Title } from './styles'

export const Headerunico = (props) => {
    const _URL_REST = globals.get('_URL_REST')

    const [listSettings, setSettings] = useState(false);
    const fetchSettings = async () => {
        const result = await axios(
            `${_URL_REST}/getsettings/${props.id}`,
        );
        setSettings(result.data[0])
    };
  
    useEffect(() => {
        fetchSettings();
    },[]);

    if(!listSettings) { return(<div></div>) } 
   
    return <Conatiner>
            <div className="contentmovile">
                <Link to='/'><Logo src={process.env.PUBLIC_URL + '/images/La-Neurona-logo.png'} alt="La Neurona" /></Link>
            </div>
            <Containerfluid>
                <ContainerTxt>
                    <LogoContainer>
                        <Title>{listSettings.cabeceraTitulo}</Title>
                        <Claim>{listSettings.cabeceraSubtitulo}</Claim>
                    </LogoContainer>
                </ContainerTxt>
            </Containerfluid> 
        </Conatiner>
    
}